export default {
  title: 'Welcome back!',
  description: `"Tell me and I forget, teach me and I may remember, involve me and I learn." - Benjamin Franklin`,
};
